import axios from 'axios';

export default {
  download(fileName, filePath) {
    return new Promise((resolve, reject) => {
      axios({ url: filePath, method: 'GET', responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  async read(filePath) {
    let data = null;
    await axios({ url: filePath, method: 'GET' }).then((response) => {
      data = response.data;
    }).catch((error) => {
      console.log(error);
    });
    return data;
  },
  api(url, method = 'GET', data = {}) {
    return new Promise((resolve, reject) => {
      axios({ url, method, data }).then((response) => {
        resolve(response);
      }).catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },
};
